<div class="ship-weeks row row-20 vacc_loc" id="tierManageSts" style="margin-top: 40px;">
  <section class="col-md-12 col-sm-12 col-xs-12 manage-tiers">
    <div class="manage-week ">
      <div class="col-md-12 pl0">
        <h6>STS Tier Management</h6>
      </div>
      <div class="upload-data">
        <button type="button" class="btn-primary stsblue-button float-right add-row" (click)="newRow()">+ New
          row</button>
      </div>
    </div>
    <div class="col-md-12">
      <table id="backoffice-table" class="backoffice-table display" style="width:100%">
        <thead>
          <tr class="heading">
            <th class="">
              Tiers</th>
            <th class="">Start Date</th>
            <th class="">End Date</th>
            <th class="">Save</th>
            <th class="">Delete</th>
          </tr>
        </thead>
        <tbody class="datatable-row" *ngIf="tierData && tierData?.length !== 0">
          <tr class="week-table-row" *ngFor="let data of tierData; let i = index">
            <td class="">
              <div class="Fields-container ">
                <input name="tier" type="number" placeholder=""
                  onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="data.tier"
                  class="Fields-input field-optional tiers text-center" autocomplete="off"
                  [ngClass]="{required: (data.tier === '' || data.tier === null) && data.active && data?.notFocused[0]}"
                  (focus)="focusValidation(data,0)" autocomplete="off">
                <span class="error-text"
                  *ngIf="(data.tier === '' || data.tier === null) && data.active && data?.notFocused[0]">This field is
                  required</span>
                <span class="error-text" *ngIf="numericCheck(data)">Tier must be numeric and unique</span>
              </div>
            </td>
            <td class="">
              <div class="Fields-container ">
                <input type="text" name="startDate" [(ngModel)]="data.startDate" placeholder=""
                  class="Fields-input field-optional start-date" (ngModelChange)="validateDate()" bsDatepicker
                  [maxDate]="maxSelectionDate" [daysDisabled]="[0, 6]"
                  [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }"
                  [ngClass]="{required: dateValidation(data,1)}" (focus)="focusValidation(data,1)"
                  onkeydown="return false">
                <span class="error-text" *ngIf="dateValidation(data,1)">Tier start date must be before
                  tier end date</span>
              </div>
            </td>
            <td class="">
              <div class="Fields-container ">
                <input type="text" name="endDate" [(ngModel)]="data.endDate" placeholder=""
                  class="Fields-input field-optional end-date" (ngModelChange)="validateDate()" bsDatepicker
                  [maxDate]="maxSelectionDate" [daysDisabled]="[0, 6]"
                  [bsConfig]="{ containerClass: 'order-list-date',dateInputFormat: 'MM/DD/YYYY' }"
                  [ngClass]="{required: dateValidation(data,2)}" (focus)="focusValidation(data,2)"
                  onkeydown="return false">
                <span class="error-text" *ngIf="dateValidation(data,2)">Tier end date must be after tier
                  start date</span>
              </div>
            </td>
            <td class="">
              <div class="Fields-container ">
                <button type="button" *ngIf="!data.insert" class="btn-primary stsblue-button"
                  (click)="update(data,i)">Update</button>
                <button type="button" *ngIf="data.insert" class="btn-primary stsblue-button"
                  (click)="update(data, i)">Insert</button>
              </div>
            </td>

            <td class="">
              <div class="Fields-container ">
                <button type="button" class="btn-primary stsblue-button" data-toggle="popover" data-placement="top"
                  data-target="save-cart-0" data-original-title="" id="linkViewDelete" aria-labelledby="cartHeading"
                  data-di-id="#linkViewDelete" [ngbPopover]="popDeltContent" [popoverTitle]="popDeltTitle"
                  triggers="manual" (click)="toggle(p3)" #p3="ngbPopover" placement="top" container="body"
                  popoverClass="popover-links tier-popover {{baseSiteId}}">Delete</button>
                <ng-template #popDeltTitle><span class="text-header">
                    Are you sure you want to delete this tier?
                  </span></ng-template>
                <ng-template #popDeltContent>
                  <button type="reset" class="btn-secondary" data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p3)">
                    Cancel
                  </button>
                  <button class="btn-primary" type="submit" data-di-id="di-id-3064f17d-e97cc628"
                    (click)="delete(data, i)">
                    Delete
                  </button>
                </ng-template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>